<script setup lang="ts">
import {onMounted, watch} from "vue";
import {useOrganizationStore} from "@/stores/organization/organization-store";
import {useAuthStore} from "@/stores/authentication-store";
import {useNavigationStore} from "@/stores/navigation-store";

const authStore = useAuthStore();
const navigationStore = useNavigationStore();

onMounted(async () => {
  await authStore.ensureHydrated()
  if (authStore.isAuthenticated()) {
    await useOrganizationStore().getFeatureToggles(true);
  }
});

//Make sure feature toggles are set in cache
watch(() => navigationStore.currentPageTranslationLabel, async (_) => {
  if (authStore.isAuthenticated()) {
    await useOrganizationStore().getFeatureToggles();
  }
})
</script>

<template>

</template>

<style scoped lang="scss">

</style>
